import { create } from 'zustand';

import { ExpirationPeriod } from '../../templates/enums/template.const';
import { SignaturePopupType } from '../enums/signature-popup-type.const';
import { SignatoryRow, SignatureRow } from '../types/signature-row.types';

export type ViewDocumentDetailsMetadata = {
  category: SignatureRow['category'];
  companyId: string;
  expirationPeriod?: ExpirationPeriod | null;
  linkedEventLabel?: null | string;
  linkedTargetId?: null | string;
  name: string;
  signatories: SignatoryRow[];
  subCategory?: SignatureRow['subCategory'];
};

export type ViewSignaturesMetadata = {
  documentName: string;
  signatories: SignatoryRow[];
};

export type SignDocumentMetadata = {
  documentName: string;
  sharesCount?: number;
  signatureId: string;
};

export type SendReminderMetadata = {
  documentName: string;
  signatureId: string;
};

type SignaturePopupMetadata =
  | null
  | SendReminderMetadata
  | SignDocumentMetadata
  | ViewDocumentDetailsMetadata
  | ViewSignaturesMetadata;

type OpenPopupPayload = {
  metadata?: SignaturePopupMetadata;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  type: SignaturePopupType;
};

type SignaturePopupStoreState = {
  handleAccept: () => void;
  handleDismiss: () => void;
  metadata: SignaturePopupMetadata;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  open: boolean;
  openPopup: (payload: OpenPopupPayload) => void;
  type: SignaturePopupType;
};

const INITIAL_STATE: Omit<
  SignaturePopupStoreState,
  'handleAccept' | 'handleDismiss' | 'openPopup'
> = {
  metadata: null,
  onAcceptCallback: undefined,
  onDismissCallback: undefined,
  open: false,
  type: SignaturePopupType.VIEW_SIGNATURES,
};

export const SignaturePopupStore = create<SignaturePopupStoreState>()((set, get) => ({
  ...INITIAL_STATE,

  handleAccept: () => {
    const callback = get().onAcceptCallback;
    set(INITIAL_STATE);
    callback?.();
  },

  handleDismiss: () => {
    const callback = get().onDismissCallback;
    set(INITIAL_STATE);
    callback?.();
  },

  openPopup: ({ type, metadata, onAcceptCallback, onDismissCallback }) => {
    set({
      metadata: metadata ?? null,
      onAcceptCallback,
      onDismissCallback,
      open: true,
      type,
    });
  },
}));
